export default {
      "Austria": "Austria",
    "Belgium": "Belgia",
    "Bulgaria": "Bulgaria",
    "Croatia": "Kroasia",
    "Cyprus": "Siprus",
    "Czechia": "Ceko",
    "Denmark": "Denmark",
    "Estonia": "Estonia",
    "Finland": "Finlandia",
    "France": "Prancis",
    "Germany": "Jerman",
    "Greece": "Yunani",
    "Hungary": "Hongaria",
    "Ireland": "Irlandia",
    "Italy": "Italia",
    "Latvia": "Latvia",
    "Lithuania": "Lituania",
    "Luxembourg": "Luksemburg",
    "Malta": "Malta",
    "Netherlands": "Belanda",
    "Poland": "Polandia",
    "Portugal": "Portugal",
    "Romania": "Rumania",
    "Slovakia": "Slowakia",
    "Slovenia": "Slovenia",
    "Spain": "Spanyol",
    "Sweden": "Swedia",
    "United Kingdom (Northern Ireland)": "Britania Raya (Irlandia Utara)",
    "Record already exists": "Rekaman sudah ada",
    "User already exists with email or mobile": "Pengguna sudah ada dengan email atau ponsel" ,
    deleteFarmH: "Apakah Anda yakin ingin menghapus pertanian ini?",
    maxLimit: "Batas maksimum tidak boleh lebih dari enam digit.",
    emptyDeforestationStatus: "Status deforestasi EUDR kosong.",
    deleteFarmMsg:
      "Harap berikan konfirmasi tambahan, karena menghapus pertanian ini akan menghapus semua informasi terkait dengan pertanian, seperti tanaman, laporan, dll.",
    "Avg Area in Hectares": "Rata-rata Area dalam Hektar",
    "Avg Area in Acres": "Rata-rata Area dalam Acre",
    "Avg Area in Manzana": "Rata-rata Area dalam Manzana",
    used: "Digunakan",
    january: "Januari",
    february: "Februari",
    march: "Maret",
    april: "April",
    may: "Mei",
    june: "Juni",
    july: "Juli",
    august: "Agustus",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Desember",
    warning: "Peringatan",
  
    meter: "Meter",
    kiloMeter: "Kilometer",
    gram: "Gram",
    kilogram: "Kilogram",
    pound: "Pound",
    cubicKilo: "Kilometer Kubik (km³)",
    cubicMeter: "Meter Kubik (m³)",
    cubicCentimeter: "Sentimeter Kubik (cm³)",
    cubicMilimeter: "Milimeter Kubik (mm³)",
    goBack: "Kembali",
    selectFileToUpload: "Pilih file untuk mengunggah data",
    totalRecords: "Total catatan",
    success: "Berhasil",
    recordsImported: "Catatan diimpor",
    psw: "Kata sandi",
    topFive: "Lima Teratas",
    deleted: "Dihapus dengan berhasil",
    failed: "Gagal",
    fermentation: "Fermentasi",
    confPsw: "Konfirmasi Kata Sandi",
    newPsw: "Kata Sandi Baru",
    email: "Email",
    emailId: "ID Email",
    submit: "Kirim",
    cancel: "Batal",
    faqs: "FAQ",
    id: "ID",
    processor: "Processor",
    cuppingScore: "Skor Cupping",
    label: "Label",
    expiry: "Kadaluarsa",
    users: "Pengguna",
    language: "Bahasa",
    appUser: "Pengguna Aplikasi",
    app_users: "Pengguna Aplikasi",
    offline_users: "Pengguna Offline",
    dimitraAdmin: "Admin Dimitra",
    admin_users: "Pengguna Admin",
    search: "Cari",
    searchByProducerName: "Cari berdasarkan nama produsen",
    searchBy: "Cari {type}",
    firstName: "Nama Depan",
    lastName: "Nama Belakang",
    mobile: "Nomor HP",
    mobileNumber: "Nomor HP",
    department: "Departemen",
    departmentName: "Nama Departemen",
    role: "Peran",
    status: "Status",
    permission: "Izin",
    activity_log: "Log Aktivitas",
    profile_auth: "Otentikasi Profil",
    countryCode: "Kode Negara",
    selectDept: "Pilih Departemen",
    selectRole: "Pilih Peran",
    edit: "Ubah",
    update: "Perbarui",
    delete: "Hapus",
    view: "Lihat",
    deactivate: "Nonaktifkan",
    activate: "Aktifkan",
    serverError: "Ada masalah. Silakan coba lagi nanti.",
    minute: "Menit",
    perHour: "Per jam",
    day: "Hari",
    enterDescription: "Masukkan deskripsi Anda di sini",
    enterHere: "Masukkan di sini",
    enterMobile: "Masukkan nomor HP",
    phoneRequired: "Nomor HP diperlukan",
    phoneValid: "Nomor HP harus valid",
    unableToUpdate: "Tidak dapat memperbarui",
    membershipPlans: "Rencana Keanggotaan",
    keysAvailable: "Kunci tersedia",
    pressImportToProceed: "Tekan Impor untuk melanjutkan",
    downloadTheSampleCsvFileToFollowTheStructure: "Unduh file .csv sampel untuk mengikuti struktur",
    pleaseUploadTheUserDataFile: "Silakan unggah file data pengguna.",
    remainingQuota: "Kuota tersisa",
    downloadTemplate: "Unduh Template",
    dragAndDropOrBrowseYourFile: "Seret dan lepas atau pilih file.",
    fileUploadedSuccessfully: "File berhasil diunggah",
    byWeek: "Per Minggu",
    byMonth: "Per Bulan",
    byYear: "Per Tahun",
    custom: "Kustom",
    name: "Nama",
    warehouse: "Gudang",
    regionState: "Region/Provinsi",
    provinceState: "Provinsi",
    cityTown: "Desa/Kota",
    membershipValidity: "Validitas Keanggotaan Dasar",
    basicPlanValidity: "Validitas Rencana Dasar",
    membershipExpiryDate: "Tanggal Kedaluwarsa Keanggotaan",
    extendedValidity: "Validitas Diperpanjang",
    exportAsCSV: "Ekspor sebagai CSV",
    filterBy: "Filter Berdasarkan",
    autoCondition: "Kondisi Otomatis",
    conditional: "Kondisional",
    comingSoon: "Segera Hadir",
    userRole: "Peran Pengguna",
    addUserRole: "Tambah Peran Pengguna",
    editUserRole: "Ubah Peran Pengguna",
    additionalInformationRequired: "Informasi Tambahan Diperlukan",
    back: "Kembali",
    browse: "Telusuri",
    clearAll: "BERSIHKAN SEMUA",
    filterByRegion: "Filter Berdasarkan Region",
    continue: "Lanjutkan",
    description: "Deskripsi",
    selectWeek: "Pilih Minggu",
    hideSplash: "Sembunyikan Layar Awal?",
    hideLogo: "Sembunyikan Logo?",
    confirm: "KONFIRMASI",
    selectMonth: "Pilih Bulan",
    selectDateRange: "Pilih Rentang Tanggal",
    regionDistrict: "Region/Distrik",
    address: "Alamat",
    familyTribe: "Suku Keluarga",
    website: "Situs Web",
    deactivated: "Nonaktif",
    active: "Aktif",
    inactive: "Tidak Aktif",
    country: "Negara",
    state: "Provinsi",
    farmer: "Petani",
    commodity: "Komoditas",
    quantity: "Kuantitas",
    unit: "Unit",
    price: "Harga",
    save: "SIMPAN",
    remove: "Hapus",
    stateIsReq: "Provinsi diperlukan",
    cityIsReq: "Kota diperlukan",
    addressIsReq: "Alamat diperlukan",
    membershipTypeReq: "Jenis keanggotaan diperlukan",
    extendedReasonReq: "Alasan perpanjangan diperlukan",
    numberOfDaysReq: "Jumlah hari diperlukan",
    extendedMembershipValidity: "Validitas Keanggotaan Diperpanjang",
    set: "SET",
    adminRole: "Peran Admin",
    typeMsg: "Ketik pesan Anda di sini",
    mile: "Mil",
    manageFarmer: "Kelola Petani",
    manageOfflineFarmers: "Kelola Petani Offline",
    dashboardSettings: "Pengaturan Dasbor",
    done: "Selesai",
    noRecordFound: "Tidak ada catatan ditemukan",
    farmerName: "Nama Petani",
    production: "Produksi",
    registered: "Terdaftar",
    downloadForReport: "UNDUH LAPORAN PDF",
    downloadPdfReport: "Unduh Laporan PDF",
    download: "UNDUH",
    notifications: "Notifikasi",
    markAllAsRead: "Tandai Semua Sebagai Sudah Dibaca",
    viewNotifications: "Lihat Notifikasi",
    youAreUpToDate: "Anda sudah terbaru",
    sendNotifications: "Kirim Notifikasi",
    createNotification: "Buat Notifikasi",
    viewAllNotifications: "Lihat semua Notifikasi",
    createNotificationForGroup: "Buat Notifikasi untuk Grup/Pengguna Ganda",
    createNotificationForDimitra: "Buat Notifikasi untuk Admin Dimitra",
    pleaseCheckTickMark:
      "Silakan centang tanda centang untuk menambahkan pengguna dalam daftar",
    clearAllFilters: "Hapus Semua Filter",
    note: "*Catatan: Hanya file Mp4 yang didukung untuk video",
    validMemberships: "Keanggotaan yang Valid",
    memberShipPlanMessage:
      "Apakah Anda yakin ingin menghapus rencana keanggotaan ini?",
    deleteMemberShipPlan: "Hapus Rencana Keanggotaan",
    systemAutoLogout: "Sistem akan logout otomatis dalam 2 menit",
    monday: "Senin",
    tuesday: "Selasa",
    Wednesday: "Rabu",
    thursday: "Kamis",
    friday: "Jumat",
    saturday: "Sabtu",
    sunday: "Minggu",
    addnewOfflineFarmer: "Tambah petani offline baru",
    export: "Ekspor",
    exportAs: "Ekspor sebagai",
    createNewOfflineFarmer: "Buat Petani Offline Baru",
    offlineFarmerForByingStationOnly:
      "Petani Offline hanya untuk stasiun pembelian (Lokal)",
    offlineFarmerForAllByingStations:
      "Petani offline untuk semua stasiun pembelian (Global)",
    noDataAvailable: "Tidak ada data yang tersedia",
    buyingStation: "Stasiun Pembelian",
    dryMillingStation: "Stasiun Penggilingan Kering",
    mergeWithExistingAccount: "Gabungkan dengan akun yang sudah ada",
    createNewAccount: "Buat akun baru",
    mobileOrEmailRequiredForRegister:
      "Untuk mendaftar aplikasi, setidaknya satu detail harus disediakan, baik nomor HP atau email.",
    selectLanguage: "Pilih bahasa",
    basicPlan: "Rencana Dasar",
    local: "Lokal",
    newUser: "Pengguna Baru",
    merged: "Digabungkan",
    global: "Global",
    qrcode: "Kode QR",
    emailSentSuccessfully: "Email berhasil dikirim",
    somethingWentWrong: "Ada yang salah",
    farms: "Perkebunan",
    farmers: "Petani",
    large: "Besar",
    medium: "Sedang",
    small: "Kecil",
    step: "Langkah",
    fileError: "Kesalahan File",
    ProvideFileFormat: "Catatan Penting: Harap berikan format berikut (PNG/JPEG)",
    signHere: "Tanda di sini",
    numOfDaysRemaining: "Jumlah Hariyang Tersisa",
    requesterNameIsRequired: "Nama Peminta diperlukan",
    messageIsRequired: "Pesan diperlukan",
    emailIsInvalid: "Email tidak valid",
    emailIsRequired: "Email diperlukan",
    read: "Baca",
    unread: "Belum Dibaca",
    all: "Semua",
    filesSucessfullyUploaded: "File berhasil diunggah",
  
    unsynced_record: "Rekaman yang Belum Disinkronkan",
  
    loadingData: "Memuat Data...",
    markAsRead: "Tandai Sebagai Sudah Dibaca",
  
    of: "dari",
    ok: "OK",
  
    orderBy: "Urutkan Berdasarkan",
    select: "Pilih",
    type: "Tipe",
    uploadImageVideo: "Unggah Gambar",
    user: "Pengguna",
    userName: "Nama Pengguna",
    usersSelected: "Pengguna Dipilih",
    topics: "Topik",
    date: "Tanggal",
    addNew: "TAMBAH BARU",
    exportAsCsv: "Ekspor sebagai CSV",
    noData: "Tidak Ada Data Ditemukan",
  
    dashboard: "Dasbor",
    mainDashboard: "Dasbor Utama",
    userDashboard: "Dasbor Pengguna",
    areYouSureText: "Apakah Anda yakin ingin melakukan tindakan ini?",
  
    tickets: {
      actions: {
        create: "Buat Tiket",
        delete: "Hapus Tiket",
        edit: "Edit Tiket",
      },
      areaOfRequest: "Area Permintaan",
      assignee: "Assignee",
      deleteTicket: {
        confirmation: "Apakah Anda yakin ingin menghapus tiket {0}?",
      },
      dueDate: "Tanggal Jatuh Tempo",
      filters: {
        ticketFor: "Tiket Untuk",
      },
      form: {
        ticketType: {
          admin: "Buat Tiket untuk Admin Dimitra",
          user: "Buat Tiket untuk Pengguna Aplikasi",
        },
      },
      markAsRead: "Tandai sebagai sudah dibaca",
      messages: {
        created: {
          success: "Tiket berhasil dibuat",
        },
        deleted: {
          success: "Tiket berhasil dihapus",
        },
      },
      noData: "Tidak Ada Tiket!",
      noDataHelpText:
        'Anda belum memiliki tiket yang ditugaskan kepada Anda. Klik tombol "Buat Tiket" di atas layar untuk memulai.',
      pickerInMenu: "Picker di menu",
      priority: {
        high: "Tinggi",
        label: "Prioritas",
      },
      reply: "Balas",
      requestedDateTime: "Tanggal dan Waktu Diminta",
      requestorDetails: "Detail Pemohon",
      requestorEmail: "Email Pemohon",
      subject: "Subjek",
      ticketsForItems: {
        all: "Semua",
        dimitraAdmin: "Admin Dimitra",
        multipleUsers: "Beberapa Pengguna",
        singleUser: "Satu Pengguna",
      },
      title: "Tiket",
    },

 faqSection: {
        createFaq: "Buat FAQ",
      createTopic: "Buat Topik",
      selectTopic: "Pilih Topik",
      faqQuestion: "Pertanyaan FAQ",
      faqAnswer: "Jawaban FAQ",
      uploadImgVid: "Unggah Gambar/Video",
      disInFaq: "Tampilkan di bagian FAQ",
      editFaq: "Edit FAQ",
      topicName: "Nama Topik",
      parentTopic: "Topik Induk",
      editTopic: "Edit Topik",
      createSection: "Silakan buat bagian terlebih dahulu",
      createTopicFirst: "Silakan buat topik terlebih dahulu",
      questionReq: "Pertanyaan FAQ wajib diisi",
      answerReq: "Jawaban FAQ wajib diisi",

      troubleshootingGuide: "Panduan Pemecahan Masalah",
      forDetailedTroubleshootingStepsAndSolutions: "Untuk langkah-langkah dan solusi pemecahan masalah secara rinci, silakan merujuk ke panduan resmi kami.",
      openTroubleshootingGuide: "Buka Panduan Pemecahan Masalah",
  
  // Default FAQ translations
  myProfile: "Profil Saya",
  myFarm: "Ladang Saya",
  myCrops: "Tanaman Saya",
  myLivestock: "Ternak Saya",
  technicalIssues: "Masalah Teknis",
  
  // Profile FAQ translations
  profileQuestion1: "Bagaimana saya bisa memasukkan informasi profil pribadi saya?",
  profileAnswer1: "Di perangkat Anda, klik ikon di pojok kiri halaman beranda. Anda akan menemukan ruang untuk mengisi nama dan alamat email kontak Anda. Anda juga harus mengisi semua detail yang diperlukan untuk membuat akun Anda",
  profileQuestion2: "Bagaimana saya mengedit profil saya?",
  profileAnswer2: "Untuk melihat dan mengedit detail profil Anda, Anda dapat mengklik nama Anda atau tombol edit tepat di sebelah nama Anda di bagian atas layar",
  profileQuestion3: "Bagaimana saya menyimpan pembaruan profil saya?",
  profileAnswer3: "Setiap kali Anda membuat atau melakukan pembaruan pada informasi akun, Anda dapat mengonfirmasi perubahan Anda dengan mengklik tombol Simpan yang terletak di bagian bawah layar Anda. Setelah disimpan, informasi akan secara otomatis diperbarui dalam sistem",
  
  // Farm FAQ translations
  farmQuestion1: "Bagaimana saya bisa mendaftarkan ladang saya?",
  farmAnswer1: "Anda dapat mengklik bagian Ladang Saya dan memilih Pendaftaran Ladang. Anda dapat memasukkan informasi yang diminta dalam formulir yang ditampilkan.",
  farmQuestion2: "Bagaimana saya mengedit informasi pendaftaran ladang saya?",
  farmAnswer2: "Detail pendaftaran ladang Anda dapat dilihat di bawah modul Ladang Saya setelah Anda mengisi formulir. Untuk mengedit detail, Anda dapat mengklik tombol edit yang terletak di layar konfirmasi detail",
  farmQuestion3: "Bagaimana saya menemukan lokasi ladang saya?",
  farmAnswer3: "Lokasi atau alamat fisik ladang Anda, serta batas fisik yang lebih tepat dari ladang Anda (Geofence) harus disediakan selama proses Pendaftaran Ladang. Detail dapat diakses melalui bagian Lokasi Saya dan Geofence Saya dari Ladang Saya di mana Anda dapat melihat informasi yang Anda masukkan dan melakukan pembaruan jika diperlukan",
  farmQuestion4: "Mengapa saya harus memasukkan tujuan saya?",
  farmAnswer4: "Menambahkan informasi tentang tujuan Anda membantu Anda melacak kemajuan Anda terhadap kriteria yang telah ditentukan sebelumnya dan memberi kami pemahaman yang lebih baik tentang cara terbaik kami dapat membantu Anda memenuhi kebutuhan Anda",
  farmQuestion5: "Mengapa saya harus mengisi formulir Audit Ladang?",
  farmAnswer5: "Tujuan bagian Audit Ladang adalah untuk menentukan apakah seorang petani berkinerja baik terhadap kriteria tertentu yang terkait dengan berbagai area ladang. Kami membantu Anda mengidentifikasi area yang perlu diperbaiki dan area di mana Anda berkinerja baik. Anda dapat mengisi formulir audit online kami atau Anda dapat menyediakan/mengunggah salah satu audit yang sudah ada untuk referensi Anda",
  farmQuestion6: "Apa tujuan bagian Dokumen Saya?",
  farmAnswer6: "Anda dapat mengunggah berbagai file dan dokumen di bawah bagian Dokumen Saya untuk kemudahan pengambilan dan referensi masa depan. Anda dapat mengorganisir dokumen Anda ke dalam folder, mencari dan memfilter untuk menemukan file yang sesuai. Anda dapat mengunggah file yang terkait dengan berbagai bagian aplikasi dari perangkat Anda",
  
  // Crops FAQ translations
  cropsQuestion1: "Bagaimana saya bisa mendaftarkan tanaman saya?",
  cropsAnswer1: "Anda dapat pergi ke modul Tanaman Saya dan memilih Pendaftaran Tanaman. Silakan masukkan data yang disebutkan dalam formulir untuk mendaftarkan tanaman Anda dalam sistem",
  cropsQuestion2: "Bagaimana saya melihat dan mengedit detail pendaftaran tanaman saya?",
  cropsAnswer2: "Setelah Anda mengisi detail mengenai tanaman Anda di bawah layar Pendaftaran Tanaman, Anda dapat melihat detail di layar konfirmasi di mana Anda juga dapat mengedit informasi dengan mengklik tombol edit yang terletak di layar yang sama",
  cropsQuestion3: "Bagaimana saya dapat menentukan jenis dan varietas tanaman?",
  cropsAnswer3: "Jenis dan varietas tanaman harus dimasukkan selama proses Pendaftaran Tanaman di mana Anda dapat memilih dari daftar jenis dan varietas tanaman yang saat ini tersedia untuk dipilih.",
  cropsQuestion4: "Apa yang harus saya masukkan di bawah bagian Observasi Tanaman?",
  cropsAnswer4: "Kondisi tanaman, kekurangan nutrisi dan detail terkait kesehatan secara keseluruhan dapat dimasukkan di bawah bagian Observasi Tanaman untuk menangkap beberapa detail tambahan terkait kinerja dan kondisi tanaman Anda. Anda dapat menggunakan bagian ini sebagai buku harian untuk observasi berkala Anda di mana Anda juga dapat menambahkan catatan ekstra dan melampirkan foto untuk membantu Anda melacak kondisi dari waktu ke waktu.",
  
  // Livestock FAQ translations
  livestockQuestion1: "Bagaimana saya bisa menambahkan tujuan saya?",
  livestockAnswer1: "Anda dapat memasukkan tujuan Anda dengan salah satu dari dua cara: baik dengan mengklik bagian Tujuan Saya di bawah modul Ladang Saya di mana Anda dapat lebih lanjut memilih apakah Anda ingin memasukkan tujuan spesifik yang terkait dengan tanaman atau ternak Anda. Anda juga dapat menemukan fungsi tujuan saya di bawah modul Ternak Saya atau Tanaman Saya untuk dapat memasukkan informasi spesifik untuk modul masing-masing. Anda dapat memasukkan beberapa tujuan.",
  livestockQuestion2: "Bagaimana saya bisa menambahkan observasi pada hewan/hewan saya?",
  livestockAnswer2: "Bagian Observasi Hewan yang terletak di bawah modul Ternak Saya adalah tempat terbaik untuk menambahkan detail apa pun tentang observasi hewan Anda. Anda dapat menambahkan detail observasi untuk salah satu hewan individual (tunggal) Anda atau sekelompok hewan (kawanan)",
  livestockQuestion3: "Informasi apa tentang ternak saya yang harus saya masukkan untuk pendaftaran hewan yang berhasil?",
  livestockAnswer3: "Silakan ikuti pertanyaan yang disajikan dalam formulir Pendaftaran Ternak. Kolom wajib ditandai dengan tanda bintang merah dan mewakili kolom yang paling penting. Kami mendorong Anda untuk memberikan informasi sebanyak mungkin karena kami akan dapat memberikan rekomendasi dan laporan yang lebih akurat yang memenuhi kebutuhan Anda",
  
  // Technical Issues FAQ translations
  technicalQuestion1: "Untuk masalah teknis apa pun, silakan hubungi kami di help@dimitra.io dengan penjelasan masalah Anda atau isi formulir online kami yang dapat ditemukan di bagian Hubungi Kami",
  technicalAnswer1: "",
},
  
    months: "Bulan",
    days: "Hari",
    open: "Buka",
    closed: "Tutup",
    moreInfoRequired: "Informasi Lebih Lanjut Diperlukan",
    publicDueDiligenceReportSettings: "Pengaturan Laporan Uji Tuntas Publik",
    fieldRequired: "Kolom ini wajib diisi.",
    valueMustBeGreaterThanZero: "Nilai harus lebih besar dari nol.",
    valueExceedsLimit:
      "Waktu kedaluwarsa tidak boleh melebihi 12 bulan sesuai dengan peraturan EUDR.",
    valueMustBeInteger: "Nilai harus berupa angka bulat.",
    reset: "mengatur ulang",
    showingAll: "Menampilkan Semua",
    viewDeforestationDetails: "Lihat Detail Risiko Deforestasi",
  
    listOfShipments: "Daftar Pengiriman",
    viewShipment: "Lihat Pengiriman",
    shipmentCratedSuccess: "Pengiriman berhasil dibuat.",
    pleaseSelectAtLeastOneDueDeligenceReport:
      "Silakan pilih setidaknya satu laporan uji tuntas",
    confirmation: "Konfirmasi",
  
    confirmDialog: {
      assessmentBuilder: {
        delete: {
          title: "Hapus Penilaian",
          message: "Apakah Anda yakin ingin menghapus Penilaian?",
          confirmBtn: "Konfirmasi?",
        },
      },
      dueDiligenceReport: {
        delete: {
          title: "Hapus Laporan Uji Tuntas EUDR",
          message: "Apakah Anda yakin ingin menghapus Laporan Uji Tuntas EUDR?",
          confirmBtn: "Konfirmasi",
        },
      },
      farm: {
        delete: {
          title: "Hapus Perkebunan",
          message: "Apakah Anda yakin ingin menghapus Perkebunan?",
          confirmBtn: "Konfirmasi",
        },
      },
      status: {
        delete: {
          title: "Hapus Status Deforestasi",
          message: "Apakah Anda yakin ingin menghapus status deforestasi?",
          confirmBtn: "Konfirmasi",
        },
      },
    },
  
    timeAgo: {
      minute: "satu menit yang lalu",
      minutes: "{count} menit yang lalu",
      hour: "satu jam yang lalu",
      hours: "{count} jam yang lalu",
      day: "satu hari yang lalu",
      days: "{count} hari yang lalu",
      month: "satu bulan yang lalu",
      months: "{count} bulan yang lalu",
      year: "satu tahun yang lalu",
      years: "{count} tahun yang lalu",
    },

    
    pleaseAgreeToDeclaration: "Silakan setujui pernyataan untuk menyelesaikan.",
    importProductionPlaceTT:
      "Memungkinkan pengguna untuk mengimpor data tempat produksi menggunakan opsi unggah atau unduh file.",
    defaultCircularGeofence:
      "Perkebunan tanpa geofence atau tanpa informasi tentang ukurannya akan diberi geofence melingkar default seluas 4 hektar. Jika ukuran rata-rata perkebunan lebih kecil dari 4 hektar, harap ubah ukuran default dengan mengklik tombol 'Edit' di bawah.",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Menurut EUDR, perkebunan dengan luas kurang dari 4 hektar tidak memerlukan poligon.",
    uploadOneDeforestationAssessmentForAllFarms:
      "UNGGAH SATU PENILAIAN DEFORESTASI UNTUK SEMUA PERTANIAN",
    uploadAssessment: "Unggah Penilaian",
    noUploadToBlockchain: "Tidak Ada Unggahan ke Blockchain",
    noDataForBlockchain:
      "Karena tidak ada laporan deforestasi yang dihasilkan untuk tempat produksi, tidak ada data untuk ditulis ke blockchain. Jika ini tidak terduga, pastikan bahwa laporan untuk pertanian telah dihasilkan dengan benar pada langkah sebelumnya.",
    seeDetails: "Lihat Detail",
    'No invasion of indigenous areas': "Tidak ada invasi ke wilayah adat",

    countries: "Negara",
    'Day/s': 'Hari/s',
    'Week/s': 'Minggu/s',
    'Month/s': 'Bulan/s',
    'Year/s': 'Tahun/s',
    tutorials: {
      howtoCreateanAdminUser: "Cara Membuat Pengguna Admin",
      howToCreateanActivationKey: "Cara Membuat Kunci Aktivasi",
      individualandBulkFarmCreation: "Pembuatan Peternakan Individu dan Massal",
      creatingaDueDiligenceStatement: "Membuat Pernyataan Uji Tuntas",
      title: "Tutorial & Panduan",
      noTutorials: "Tidak Ada Tutorial",
      addTutorialPrompt: "Silakan tambahkan tutorial atau panduan terlebih dahulu.",
      videoNotAvailable: "Video tidak tersedia dalam bahasa pilihan Anda.",
      watchVideo: "Tonton Video",
      viewTutorial: "Lihat Tutorial",
      // Kenyan tutorials
      creatingAndManagingUsers: "Membuat dan Mengelola Pengguna",
      howToCreateActivationKeys: "Cara Membuat Kunci Aktivasi",
      userRolesAndPermissions: "Peran dan Izin Pengguna",
      creatingAFarm: "Membuat Peternakan",
      creatingADueDiligenceStatement: "Membuat Pernyataan Uji Tuntas",
      sharingStatementWithOperator: "Berbagi Pernyataan dengan Operator",
      riskMitigation: "Mitigasi Risiko",
      generalSettings: "Pengaturan Umum",
      assessmentBuilder: "Pembangun Penilaian",
      bulkUserUpload: "Upload Pengguna Massal",
      // Admin management
      manageTutorials: "Kelola Tutorial",
      createTutorial: "Buat Tutorial",
      editTutorial: "Edit Tutorial",
      deleteTutorial: "Hapus Tutorial",
      deleteConfirmation: "Apakah Anda yakin ingin menghapus tutorial '{title}'?",
      createSuccess: "Tutorial berhasil dibuat",
      updateSuccess: "Tutorial berhasil diperbarui",
      deleteSuccess: "Tutorial berhasil dihapus",
      createError: "Kesalahan saat membuat tutorial",
      updateError: "Kesalahan saat memperbarui tutorial",
      deleteError: "Kesalahan saat menghapus tutorial",
      saveError: "Kesalahan saat menyimpan tutorial",
      loadError: "Kesalahan saat memuat tutorial",
      createFirstTutorial: "Buat tutorial pertama Anda untuk memulai",
      // Form fields
      description: "Deskripsi",
      url: "URL",
      urlType: "Jenis Konten",
      displayOrder: "Urutan Tampilan",
      organization: "Organisasi",
      organizationHint: "Pilih 'Global' untuk tutorial yang tersedia untuk semua organisasi, atau pilih organisasi tertentu",
      userType: "Jenis Pengguna",
      userTypeHint: "Pilih jenis pengguna mana yang dapat melihat tutorial ini",
      isActive: "Aktif",
      status: "Status",
      actions: "Tindakan",
      // Status options
      active: "Aktif",
      inactive: "Tidak Aktif",
      global: "Global",
      // User types
      appUsers: "Pengguna App",
      adminUsers: "Pengguna Admin",
      // Validation messages
      titleRequired: "Judul wajib diisi",
      titleMinLength: "Judul harus minimal 3 karakter",
      urlRequired: "URL wajib diisi untuk tautan eksternal",
      urlInvalid: "Silakan masukkan URL yang valid",
      urlTypeRequired: "Jenis konten wajib diisi",
      fileRequired: "File wajib diisi untuk tutorial berbasis file",
      urlOrFileRequired: "URL atau file harus disediakan",
      // Search functionality
      searchOrganizations: "Cari organisasi...",
      noOrganizationsFound: "Tidak ada organisasi ditemukan",
      searchTutorials: "Cari tutorial...",
      selectOrganization: "Pilih organisasi..."
    },
    helpDesk: "Pusat Bantuan",
  };
  